{{#if label}}
  <label for="{{id}}">{{t label}}</label>
{{/if}}
{{#if (equal helptext.position 'top')}}
  <p class="helptext"><small>{{t helptext.text}}</small></p>
{{/if}}
<input type="text" id="{{id}}" value="{{default_value}}" {{#if attributes}}data-attributable{{/if}} />
{{#if (equal helptext.position 'bottom')}}
  <p class="helptext"><small>{{t helptext.text}}</small></p>
{{/if}}